import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IconsModule, KENDO_ICONS } from '@progress/kendo-angular-icons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ButtonsModule, KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import { KENDO_LABELS, LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule, KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { Subscription } from 'rxjs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { GridModule } from '@progress/kendo-angular-grid';
import { PagerModule } from '@progress/kendo-angular-pager';
import { IconName, IconPrefix, IconProp } from '@fortawesome/fontawesome-svg-core';
import { KENDO_TOOLBAR } from '@progress/kendo-angular-toolbar';
import { AutoFocusDirective } from '../../directives/auto-focus.directive';
import { ConfirmModalComponent } from '../../common-components/confirm-modal/confirm-modal.component';
import { CasiKendoEditorComponent } from '../../common-components/casi-kendo-editor/casi-kendo-editor.component';
import { EditorImageUploadComponent } from '../../common-components/editor-image-upload/editor-image-upload.component';
import {
  CasiOwnerUser,
  CasiProjectLabel,
  CasiStoryEstimate, CasiStoryPriority, CasiStoryStatus,
  CasiStoryType, CasiUserStory, Project, User as UserModel
} from '../../models/models.lib';
import { LoggerService } from '../../shared/logger.service';
import { FormModes } from '../../common/constants.lib';
import { ProjectUserService } from '../../tracker/project-user.service';
import { StatusButtonComponent } from '../../common-components/status-button/status-button.component';
import {ProjectLabelService} from "../../tracker/project-label.service";

@Component({
  selector: 'casi-project-label-add',
  standalone: true,
  imports: [
    CommonModule,
    LayoutModule,
    InputsModule,
    FormsModule,
    ReactiveFormsModule,
    IconsModule,
    ButtonsModule,
    InputsModule,
    LabelModule,
    DropDownsModule,
    AutoFocusDirective,
    FontAwesomeModule,
    GridModule,
    PagerModule,
    // KENDO_DROPDOWNS, KENDO_LABELS, KENDO_ICONS,
    // KENDO_BUTTONS,
    // KENDO_TOOLBAR,
    ConfirmModalComponent,
    CasiKendoEditorComponent,
    EditorImageUploadComponent,
    StatusButtonComponent
  ],
  templateUrl: './project-label-add.component.html',
  styleUrl: './project-label-add.component.scss'
})
export class ProjectLabelAddComponent implements OnInit, OnDestroy, AfterContentInit {


  private _projectLabel: CasiProjectLabel | undefined;

  @Input({ required: true }) set projectLabel(val: CasiProjectLabel) {
    this._projectLabel = val;
    this.logger.debug(`input:projectLabel: `, this._projectLabel);
    this.form.patchValue(this._projectLabel);
  }
  get projectLabel() {
    return (this._projectLabel as CasiProjectLabel);
  }

  @Output() onSave = new EventEmitter<FormGroup>();
  @Output() onCancel = new EventEmitter<void>();


  form: FormGroup;

  @ViewChild('pForm') pForm!: ElementRef;

  private _subs: Subscription[] = [];

  constructor(
    private logger: LoggerService,
    public faIcons: FaIconLibrary,
    private fb: FormBuilder,
    private projectLabelService: ProjectLabelService
  ) {
    faIcons.addIcons(...all);
    this.form = this.fb.group(
      {
        id: [null, []],
        project_id: [null, [Validators.required]],
        project_label_description: [null, [Validators.required]]
      }
    );
  }

  //#region NG Event Handlers

  ngOnInit(): void {
    // this.logger.debug('ngOnInit...');
  }

  ngOnDestroy(): void {
    // this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  ngAfterContentInit(): void {
    // this.logger.debug('ngAfterContentInit...');
  }

  //#endregion

  //#region Form Properties

  get f() {
    return this.form.controls;
  }
  get titleIsDirty() {
    return this.form.dirty;
  }
  get id() {
    return this.form.get('id');
  }
  get idValue() {
    return this.form.get('id')?.value;
  }
  get project_id() {
    return this.form.get('project_id');
  }
  get project_label_description() {
    return this.form.get('project_label_description');
  }

  //#endregion

  //#region Public functions
  onSubmit(): void {
    this.logger.debug(`onSubmit...`, this.form.value);
    this.onSave.emit(this.form);
  }

  closeWindow(): void {
    this.logger.debug(`closeWindow...`);
    this.onCancel.emit();
  }



  //#endregion

  //#region Private functions
  //#endregion

}

